import { useNavBar } from "@cede/ds";
import { NavBar as AppBar } from "./NavBar";

export const NavBar = () => {
  const { leftSide, center, rightSide, isDisplayed } = useNavBar();
  return <AppBar leftSide={leftSide} center={center} rightSide={rightSide} isDisplayed={isDisplayed} />;
};
